// jquery-global.js
import $ from 'jquery';
import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery;